






























import { computed, defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { ProductVariant } from '~/utils/ct/types/product/ProductVariant';
import {
  getProductAttributesExtended,
} from '~/helpers/product/getProductAttributesExtended';
import { SCHEMA_ITEM_PROP } from '~/constants/seo';
import { PRODUCT_ATTRIBUTES } from '~/constants/products';

export default defineComponent({
  name: 'ProductAttributeWrapper',
  components: {
    ProductAttribute: () => import(/* webpackChunkName: "ProductAttribute" */
      '~/components/molecules/Product/ProductAttribute.vue'),
    ShareUrl: () => import(/* webpackChunkName: "ShareUrl" */
      '~/components/atoms/ShareUrl/ShareUrl.vue'),
  },
  props: {
    product: {
      type: Object as PropType<ProductVariant>,
      required: true,
    },
  },
  setup(props: { product: ProductVariant }) {
    const sku = computed(() => props.product?.sku ?? '');
    const model = computed(() => getProductAttributesExtended(
      props.product,
      {
        attributeNames: [PRODUCT_ATTRIBUTES.MODEL],
      },
    )[PRODUCT_ATTRIBUTES.MODEL]);
    return {
      sku,
      model,
      SCHEMA_ITEM_PROP,
    };
  },
});
